<template>
	<v-container fluid>

								<v-layout row wrap>
									<v-flex xs12>
										<v-icon>fa-sync-alt</v-icon>
										<span style="font-size: 18px; color:gray;">&nbsp;&nbsp;{{
												$t('labels.syncPortals')
											}}</span>
									</v-flex>
									<v-flex xs12 text-xs-right pt-3>
										<v-btn @click="syncAllPortals" color="grey lighten-1">
											<v-icon small>fa-sync-alt</v-icon>&nbsp;&nbsp;{{ $t('buttons.syncAll') }}
										</v-btn>
									</v-flex>
									<v-flex xs12>
										<table class="table">
											<tr>
												<th>
													{{ $t('fields.website') }}
												</th>
												<th>
													{{ $t('fields.statusXml') }}
												</th>
												<th>
													{{ $t('fields.dateOfXml') }}
												</th>
											</tr>
											<tr v-for="(item, key) in automaticPortals"
												:key="key" :class="{'website-error' : item.status == 'Greška'}">

												<td>
													{{item.name}}
												</td>
												<td>
													{{item.status}}

													<v-btn v-if="item.hasError == true" small @click="showErrors(item.html_string)" icon slot="activator">
														<v-icon small>fa-info-circle</v-icon>
													</v-btn>
												</td>
												<td>
													{{item.last_generated_at}}
												</td>
											</tr>
										</table>
									</v-flex>
								</v-layout>

	</v-container>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import CheckBox from "./trinkets/CheckBox";
import InputField from "./trinkets/InputField";
import UploadMultiple from "./trinkets/UploadMultiple";
import CurrencyField from './trinkets/CurrencyField.vue';
import Autocomplete from "./trinkets/Autocomplete";
import Dropdown from "./trinkets/Dropdown";
import Opportunity from "../models/Opportunity";
import {LazyYoutube} from "vue-lazytube";
import Lightbox from 'vue-easy-lightbox';
import DropdownMultiple from "./trinkets/DropdownMultiple";
import TextArea from "./trinkets/TextArea";
import DatePicker from './trinkets/DatePicker';
import QuantityField from './trinkets/QuantityField';
import PartnerEmailModal from "./PartnerEmailModal";

export default {
	name: 'App',
	components: {
		PartnerEmailModal,
		CheckBox,
		InputField,
		Editor,
		CurrencyField,
		UploadMultiple,
		Autocomplete,
		Dropdown,
		LazyYoutube,
		Lightbox,
		DropdownMultiple,
		TextArea,
		DatePicker,
		QuantityField
	},
	data() {
		return {
			tabId: 0,
			results: null,
			initialLoad: false,
			languages: [],
			descriptions: [],
			publicPath: process.env.BASE_URL,
			opportunity: new Opportunity({}),
			showCityDropdown: true,
			showLocationName: true,
			partners: [],
			automaticPortals: [],
			websites: {
				1: {
					name: 'portal 1',
					status: 'Zadnja uspješna sinkronizacija',
					date: new Date().toISOString().slice(0, 10),
					selected: false
				},
				2: {
					name: 'portal 2',
					status: 'Greška',
					date: new Date().toISOString().slice(0, 10),
					selected: false
				},
				3: {
					name: 'portal 3',
					status: 'Zadnja uspješna sinkronizacija',
					date: new Date().toISOString().slice(0, 10),
					selected: false
				}
			},
			videoLinks: [],
			vtigerObject: '',
			emailRecipients: [],
			imageGalleryShow: false,
			watermarkedImageGalleryShow: false,
			index: 0,
			imageList: [],
			watermarkedImageList: [],
			opportunityCategory: null,
			validatedList: [],
			partnerEmailModal: {
				show: false,
				partner: null,
				opportunity: null
			},
			currentPartnerIndex: null,
			hasErrors: false,
			htmlString: '',
		}
	},
	watch: {
		opportunity: {
			handler: function () {
				if (this.initialLoad) {
					this.changesHappened = true;
				}
			},
			deep: true
		},
		"opportunity.location_county_id": {
			handler: function () {
				this.showCityDropdown = false;
				if (this.initialLoad) {
					this.opportunity.location_city_id = null;
				}
				this.$nextTick(() => {
					this.showCityDropdown = true;
				});
			},
			deep: true
		},
		"opportunity.location_city_id": {
			handler: function () {
				this.showLocationName = false;
				if (this.initialLoad) {
					this.opportunity.location_name = '';
				}
				this.$nextTick(() => {
					this.showLocationName = true;
				});
			},
			deep: true
		},
		"opportunity.videos": {
			handler: function () {
				this.videoLinks = [];
				for (const element of this.opportunity.videos) {
					if (element != null) {
						let regExp = /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
						let match = element.match(regExp);
						if (match) {
							this.videoLinks.push(element);
						} else {
							this.videoLinks.push(null);
						}
					}
				}
			},
			"opportunity.photos":{
				handler: function() {
					this.imageList = [];
					for (const element of this.opportunity.photos){
						if(element != null){
							this.imageList.push(element.link);
						}
					}
				}
			},
			"opportunity.watermarked_photos":{
				handler: function() {
					this.watermarkedImageList = [];
					for (const element of this.opportunity.watermarked_photos){
						if(element != null){
							this.watermarkedImageList.push(element.link);
						}
					}
				}
			},
		},
	},
	computed: {},
	methods: {


		empty() {

		},

		editClick(item) {
			item.selected = !item.selected;
		},
		back() {
			if (this.initialLoad) {
				this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
					if (result) {
						this.$router.push('/opportunities/');
					}
				});
			} else {
				this.$router.go(-1);
			}
		},



		generateXml(portal){
			let vm = this;
			this.$APICall('get', 'automatic-portals/xml/'+ portal, {}, (data, success) => {
			if (success) {
				if (success) {
					this.$router.go();
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}
		});

		},
		showErrors(htmlString){
			this.$alertHtml(htmlString);
		},

		syncAllPortals(){
			let vm = this;
			this.$APICall('get', 'automatic-portals/xml-sync-all', {}, (data, success) => {
			if (success) {
				if (success) {
					vm.$notify(vm.$t('alerts.basicUpdate'));
					this.$router.go();
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}
		});

		},
		vtigerLink() {
			window.open(this.vtigerObject.opportunity.vtiger_link, '_blank');
		},
	},
	mounted() {
		let vm = this;
		this.$APICall('get', 'automatic-portals', {}, (data, success) => {
			if (success) {
					/* vm.vtigerObject = data; */
					vm.$myStore.commit('setBreadcrumbs', [
						{text: this.$t('modules.automaticPortals'), href: '/#/automatic-portals', disabled: false},
						{text: this.$route.params.id, href: '/#/automatic-portals/' + this.$route.params.id, disabled: true}
					]);


							let usableData4 = JSON.parse(JSON.stringify(data['automaticPortals']));
							vm.results = true;
							vm.$nextTick(() => {
								vm.initialLoad = true;
							});
							vm.automaticPortals = usableData4;
			}


			}
		);

	}
}
</script>

<style scoped>
.files-container {
	margin: 5px;
	padding: 5px;
	border: 1px solid rgb(206, 206, 206);
	border-radius: 3px;
	min-height: 130px;
	max-height: 250px;
	overflow-x: auto;
}

.file-tile {
	margin: 2px;
	padding: 2px;
	height: 180px;
	width: 120px;
	text-align: center;
	display: inline-block;
	overflow: hidden;
	word-wrap: break-word;
}

.file-tile:hover {
	background-color: rgb(240, 240, 240);
}

.tile-image {
	margin: 2px;
	padding: 2px;
	height: 100px;
	width: 116px;
	overflow: hidden;
}

.tile-image:hover {
	cursor: pointer;
}

.tile-text {
	margin: 2px;
	padding: 2px;
	height: 30px;
	width: 116px;
	font-size: 10px;
	overflow: hidden;
}

.tile-buttons {
	margin: 2px;
	padding: 2px;
	height: 18px;
	width: 116px;
}

.table {
	font-family: Helvetica, sans-serif;
	font-size: 13px;
	border-collapse: collapse;
	border-radius: 6px;
	width: 100%;
	text-align: center;
	overflow: hidden;
	background-color: #ffffff;
	color: rgb(34, 34, 34);
}

.table td, .table th {
	padding: 6px;
}

.table th {
	font-size: 15px;
	font-weight: bold;
	padding-top: 8px;
	padding-bottom: 8px;
	background-color: #cacaca;
	opacity: 0.9;
}

.table tr:nth-child(even) {
	background-color: #e8e8e8;
}

.table td:first-child {
	text-align: center;
}

.table tr:hover {
	background-color: #ddd;
}

.website-error {
	color: rgb(131, 10, 10);
}
</style>
